module.exports = __webpack_public_path__ + "static/img/02bg.e0a3fce.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/share/14friendDesc/02bg.png
// module id = 438k
// module chunks = 0